module.exports = __webpack_public_path__ + "img/shekel-sign.ca8b44a9.svg";